import GenericCard from '../components/UI/GenericCard'
import ListProducts from '../components/products/ListProducts'

const Products = () => {
    return <GenericCard title="List of Products"><ListProducts /></GenericCard>
}

export default Products